import "core-js/modules/es.array.push.js";
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue";
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';
import vi from 'element-plus/es/locale/lang/vi';
import { ElNotification, ElMessageBox, ElMessage, ElConfigProvider } from "element-plus";
import { onMounted, nextTick, computed } from "vue";
import { useI18n } from "vue-i18n";
import useUserStore from "@/store/modules/user";
import { ResizeObserverBug } from "@/hook/index.js";
import { useRouter, onBeforeRouteUpdate } from "vue-router";
import { useThemeStore } from '@/store/modules/themeStore';
import Cookies from 'js-cookie';
export default {
  __name: 'App',
  setup(__props) {
    // 导入 Element Plus 的官方语言包
    const {
      t,
      locale
    } = useI18n();
    const router = useRouter();
    const themeStore = useThemeStore();
    onMounted(() => {
      localStorage.setItem('originalRoutes', JSON.stringify(router.options.routes[7].children));
      nextTick(() => {
        themeStore.initialize();
      });
    });
    const elLocale = computed(() => {
      const langMap = {
        'zh_CN': zhCn,
        'en_US': en,
        'vi_VN': vi
      };
      return langMap[locale.value] || zhCn;
    });
    ResizeObserverBug();
    if (location.pathname !== "/login") {
      useUserStore().getInfo().then(res => {
        if (res === undefined) return;
        if (res.level == 1 && router.currentRoute.value.meta.authorityUser == undefined && !!Cookies.get('Admin-Token')) {
          ElMessageBox.alert(t("FormC.ElMessageBox.title5"), t("FormC.ElMessageBox.tips"), {
            confirmButtonText: t("FormC.confirm"),
            callback: action => {
              // location.href = "/mag/user/index"; 
              router.push("/mag/user/user");
            }
          });
        } else {
          // router.push('/login')  
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: elLocale.value
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, null, {
          default: _withCtx(({
            Component
          }) => [(_openBlock(), _createBlock(_KeepAlive, null, [_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: 0
          })) : _createCommentVNode("", true)], 1024)), !_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["locale"]);
    };
  }
};